module.exports = __webpack_public_path__ + "media/images/visitor-new-4dcf186b.svg";